"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Variables = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Picker = _interopRequireDefault(require("./Picker.js"));
var _md = _interopRequireDefault(require("md5"));
require("./style.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Variables = exports.Variables = /*#__PURE__*/function (_React$Component) {
  function Variables() {
    var _this;
    _classCallCheck(this, Variables);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Variables, [].concat(args));
    _defineProperty(_this, "addVariable", function (values) {
      var variable = values.variable,
        userName = values.userName;
      var hash = (0, _md["default"])("".concat(new Date().getTime(), "_").concat(Math.random())).substr(0, 5);
      var code = "".concat(variable.category, "_").concat(hash);
      var meta = _objectSpread(_objectSpread({}, _this.props.meta), {}, {
        variables: _objectSpread(_objectSpread({}, _this.props.meta.variables), {}, _defineProperty({}, code, variable))
      });
      _this.props.insertContent("<span spellcheck=\"false\" class=\"cccisd-wysiwyg-variable mceNonEditable\" data-variable=\"".concat(code, "\">").concat(userName, "</span>"), meta);
    });
    _defineProperty(_this, "getInitialValues", function () {
      var _this$props = _this.props,
        selectedContent = _this$props.selectedContent,
        meta = _this$props.meta;
      var result = selectedContent.match(/<span[^>]*data-variable="([^"]*)"[^>]*>([^<]*)<\/span>/);
      if (result && meta.variables && meta.variables[result[1]]) {
        return {
          variable: meta.variables[result[1]],
          userName: result[2]
        };
      }
      return {
        variable: null,
        userName: ''
      };
    });
    return _this;
  }
  _inherits(Variables, _React$Component);
  return _createClass(Variables, [{
    key: "render",
    value: function render() {
      if (!this.context.flow) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "WYSIWYG-editor should be inside the flow to be able to pick variables");
      }
      var DataConnectorsPicker = this.context.flow.DataConnectorsPicker;
      return /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
        DataConnectorsPicker: DataConnectorsPicker,
        onSubmit: this.addVariable,
        initialValues: this.getInitialValues()
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Variables, "propTypes", {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  insertContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string
});
_defineProperty(Variables, "contextTypes", {
  flow: _propTypes["default"].object
});
var _default = exports["default"] = {
  name: 'cccisdVariables',
  text: 'Var',
  tooltip: 'Add variables',
  title: 'Add variables',
  component: Variables,
  modalSize: 'large',
  activeCondition: function activeCondition(element) {
    return element.className === 'cccisd-wysiwyg-variable';
  }
};